import React, { useRef, useState, useEffect } from 'react';

const CameraCapture = ({ setCustomerImageFile, onCapture, disabled = false }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [image, setImage] = useState(null);
  const [stream, setStream] = useState(null);

  useEffect(() => {
    const startCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        videoRef.current.srcObject = stream;
        setStream(stream);
      } catch (err) {
        console.error("Error accessing camera: ", err);
      }
    };

    startCamera();

    return () => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  const capturePhoto = () => {
    if (disabled) return;
    const canvas = canvasRef.current;
    const video = videoRef.current;

    if (video && canvas) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      const dataUrl = canvas.toDataURL('image/png');

      // Convert base64 to Blob
      const byteString = atob(dataUrl.split(',')[1]);
      const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];

      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([ia], { type: mimeString });
      const file = new File([blob], 'captured-image.png', { type: mimeString });
      const objectUrl = URL.createObjectURL(file);

      setImage(objectUrl);
      if(onCapture){
        onCapture(objectUrl);
      }
      setCustomerImageFile(file);
    }
  };

  const retakePhoto = () => {
    setImage(null);
  };

  return (
    <div>
      {!image && (
        <video
          ref={videoRef}
          style={{ width: '100%', maxWidth: '500px' }}
          autoPlay
          playsInline
          muted
        />
      )}

      {image && (
        <img
          src={image}
          alt="Captured"
          style={{ width: '100%', maxWidth: '500px', marginTop: '10px' }}
        />
      )}

      <canvas ref={canvasRef} style={{ display: 'none' }} />

      <div style={{ marginTop: '10px' }}>
        {image ? (
          <button onClick={retakePhoto}>🔄 Retake</button>
        ) : (
          <button onClick={capturePhoto}
          disabled={disabled}
          >📸 Capture</button>
        )}
      </div>
    </div>
  );
};

export default CameraCapture;